<template>
  <div class="search-qls" v-if="items && items.length > 0">
    <div class="search-ql-header">
      <h3>Quick Links</h3>
    </div>

    <div class="search-ql-container">
      <div class="search-ql" v-for="item of items">
        <a :href="item.link">{{ item.label }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchQuickLink",

  data() {
    return {
      items: [],
    };
  },

  created() {
    this.$store
      .dispatch("fetchQuickLinks")
      .then((response) => (this.items = response))
      .catch((err) => {
        console.error(err);
      });
  },
};
</script>

<style scoped>
.search-qls {
  max-width: 210px;
  padding: 12px 10px;
  border: 1px solid var(--wwfTransparentBlack015);
}

.search-qls h3 {
  margin-left: 10px;
  margin-right: 10px;
}

.search-ql {
  padding: 6px 10px;
}

.search-ql a {
  font-size: 16px;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// SearchQuickLink.vue?7cc720c7